module.exports = __webpack_public_path__ + "statics/img/alipay.cde19bb4.png";